import { Box, Typography } from '@mui/material'
import { useComponentSizeAndPosition } from '../shared/utils'
import { DVD } from './DVD'
import { NavBar } from './Navigation'
import { LoadingPicture } from '../shared/LoadingPicture'

export function Attire() {
  const isMobile = window.innerWidth <= 768

  return isMobile ? <AttireMobile /> : <AttireDesktop />
}

function AttireMobile() {
  const { boxRef, width, height } = useComponentSizeAndPosition()

  return (
    <Box
      ref={boxRef}
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {width && height && (
        <DVD
          containerHeight={height}
          containerWidth={width}
          initialX={width - 75}
          initialY={height - 120}
          radius={100}
          text="Big yellow button"
        />
      )}
      <Box
        sx={{
          padding: '10px',
          bottom: 0,
          width: '100%',
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 1.0)',
        }}
      >
        <NavBar direction="row" />
      </Box>
      <Friday />
      <Saturday />
    </Box>
  )
}

function AttireDesktop() {
  const { boxRef, width, height } = useComponentSizeAndPosition()
  return (
    <Box
      ref={boxRef}
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {width && height && (
        <DVD
          containerHeight={height}
          containerWidth={width}
          initialX={width - 75}
          initialY={height - 120}
          radius={100}
          text="Big yellow button"
        />
      )}
      <Box
        sx={{
          padding: '10px',
          bottom: 0,
          width: '100%',
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 1.0)',
        }}
      >
        <NavBar direction="row" />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: '40px' }}>
        <Friday />
        <Box
          sx={{
            marginLeft: '25px',
            marginRight: '25px',
            border: '1px solid black',
          }}
        ></Box>
        <Saturday />
      </Box>
    </Box>
  )
}

function Friday() {
  const isMobile = window.innerWidth < 768
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '36px',
        maxWidth: '450px',
      }}
    >
      <Box
        sx={{
          height: isMobile ? '80px' : '120px',
          width: isMobile ? '160px' : '240px',
          borderRadius: '50%',
          border: '2px solid',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '16px',

          marginBottom: '16px',
        }}
      >
        <Typography variant="body1" paragraph fontWeight="bold" fontSize={24}>
          Friday
        </Typography>
      </Box>
      <LoadingPicture
        imageId="friday.png"
        size="medium"
        stage="prod"
        style={{
          // height: 'calc(100vh - 100px)',
          width: '100%',
          //   minWidth: '300px',
          marginBottom: '24px',
        }}
      />
      <Typography variant="body1" paragraph fontWeight="bold">
        Evening garden party
        <br />
        - Garden does not mean you need to wear florals
        <br />
        - Semi formal (jackets not required)
        <br />
        - No flip flops (we will roast you)
        <br />- No white obviously
      </Typography>
    </Box>
  )
}

function Saturday() {
  const isMobile = window.innerWidth < 768
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '36px',
        maxWidth: '450px',
      }}
    >
      <Box
        sx={{
          height: isMobile ? '80px' : '120px',
          width: isMobile ? '160px' : '240px',
          borderRadius: '50%',
          border: '2px solid',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '16px',

          marginBottom: '16px',
        }}
      >
        <Typography variant="body1" paragraph fontWeight="bold" fontSize={24}>
          Saturday
        </Typography>
      </Box>
      <LoadingPicture
        imageId="saturday.png"
        size="medium"
        stage="prod"
        style={{
          // height: 'calc(100vh - 100px)',
          width: '100%',
          //   minWidth: '300px',
          marginBottom: '24px',
        }}
      />
      <Typography variant="body1" paragraph fontWeight="bold">
        Dinner party in a field
        <br />
        - Not black tie
        <br />
        - Chic, polished
        <br />
        - Have fun with it
        <br />- No white obviously
        <br />- You will be walking on grass all evening
      </Typography>
    </Box>
  )
}
